// extracted by mini-css-extract-plugin
export default {"prosemirrorStyles":"styles-module__prosemirrorStyles__src-labstep-web-prosemirror-ReadOnly-_bqp7Z styles-module__prosemirrorStyles__src-labstep-web-prosemirror-_LutVq"};